import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {GuestComponent} from '../../../layout/guest/guest.component';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {LoaderService} from '../../../../services/loader/loader.service';
import {NgForOf, NgOptimizedImage} from '@angular/common';
import {Country} from '../../../../models/country';
import {ConfigService} from '../../../../services/config/config.service';
import {LangService} from '../../../../services/language/lang.service';
import {DropdownSelectComponent} from '../../../layout/dropdown-select/dropdown-select.component';
import {DropdownSelectOptionComponent} from '../../../layout/dropdown-select-option/dropdown-select-option.component';
import {MetaTitle} from '../../../../decorator/meta-title';
import {TranslatePipe} from '@ngx-translate/core';
import {RegisterService} from '../../../../services/register/register.service';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';
import {FormError} from '../../../../tools/form-error/form-error';
import {FormErrorComponent} from '../../../layout/form-error/form-error.component';
import {ConstantList} from '../../../../models/constant-list';

@Component({
  selector: 'app-register',
  imports: [
    RouterLink,
    GuestComponent,
    ReactiveFormsModule,
    NgForOf,
    DropdownSelectComponent,
    DropdownSelectOptionComponent,
    FormsModule,
    NgForOf,
    NgOptimizedImage,
    ReactiveFormsModule,
    TranslatePipe,
    FormErrorComponent
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
@MetaTitle('Register')
export class RegisterComponent implements OnInit {
  countries: Country[] = [];
  trafficSourceList: string[] = [];
  typologyList: string[] = [];
  experienceList: string[] = [];
  verticalList: ConstantList[] = [];
  estimatedMonthlyRevenueList: string[] = [];
  geographicAreaList: string[] = [];

  form = new FormGroup({
    companyName: new FormControl('', Validators.required),
    firstname: new FormControl('', Validators.required),
    lastname: new FormControl('', Validators.required),
    address: new FormControl('', Validators.required),
    zipCode: new FormControl('', Validators.required),
    city: new FormControl('', Validators.required),
    state: new FormControl(''),
    country: new FormControl('', Validators.required),
    email: new FormControl('', Validators.required),
    phoneNumber: new FormControl('', Validators.required),
    langs: new FormControl<string[]>([], Validators.required),
    telegram: new FormControl(''),
    teams: new FormControl(''),
    trafficSourceList: new FormControl<string[]>([], Validators.required),
    typology: new FormControl('', Validators.required),
    experience: new FormControl('', Validators.required),
    verticals: new FormControl<string[]>([], Validators.required),
    estimatedMonthlyRevenue: new FormControl('', Validators.required),
    geographicAreaList: new FormControl<string[]>([], Validators.required),
    websiteUrl: new FormControl('', Validators.required),
  });

  formError = new FormError();

  constructor(
    private loader: LoaderService,
    private configService: ConfigService,
    private registerService: RegisterService,
    private route: ActivatedRoute,
    private router: Router,
    private snackbar: SnackbarService,
    protected langService: LangService,
  ) {
  }

  ngOnInit(): void {
    this.configService.load().subscribe((config) => {
      this.countries = config?.countries ?? [];
      this.trafficSourceList = config?.data?.trafficSourceList;
      this.typologyList = config?.data?.typologyList;
      this.experienceList = config?.data?.experienceList;
      this.verticalList = config?.data?.verticalList.map((vertical: any) => new ConstantList().deserialize(vertical));
      this.estimatedMonthlyRevenueList = config?.data?.estimatedMonthlyRevenueList;
      this.geographicAreaList = config?.data?.geographicAreaList;
    });
  }

  getLangs(): any[] {
    return this.langService.getPartnerLangs();
  }

  onSubmit(): void {
    this.formError.clearErrors();
    this.formError.setFormGroupErrors(this.form);

    if (!this.form.valid) {
      return;
    }

    const data: any = this.form.value;
    if (this.route.snapshot.queryParamMap.has('amid')) {
      data['accountManagerId'] = this.route.snapshot.queryParamMap.get('amid');
    }

    this.loader.startLoading();
    this.registerService.register(data).subscribe({
      next: () => {
        this.loader.stopLoading();
        this.router.navigate(['/register/success']).then();
      },
      error: (error) => {
        this.formError.setApiResponseErrors(error);

        if (error.code === 409) {
          this.snackbar.error('An account with this email already exists.', null, 3000);
        }
      }
    });
  }
}
